package one.healthium.di

import one.healthium.Platform
import org.koin.dsl.module

actual fun sharedPlatformModule() = module {
    single { Platform() }
}